function selectElement(id, valueToSelect) {    
  let element = document.getElementById(id);
  element.value = valueToSelect;
}

var DailyDealOneIds = {};
var DailyDealTwoIds = {};
var DailyDealThreeIds = {};
var DailyDealFourIds = {};

var DailyDealOnePrices = {};
var DailyDealTwoPrices = {};
var DailyDealThreePrices = {};
var DailyDealFourPrices = {};

$.getJSON('https://shirtpunch-store.myshopify.com/collections/frontpage/products.json', function(data) {
    // JSON result in 'data' variable
    
  	// console.log(data.products);
  
  	if (data.products.length != 0){
  
      // 1. Create Variant ID Dictionary
      var myArray = data.products[0].variants;
      // console.log(myArray);
      var arrayLength = myArray.length;
      for (var i = 0; i < arrayLength; i++) {
        var variant_id = myArray[i].id;
        // console.log(id);
        DailyDealOneIds[myArray[i].title] = variant_id;
      }  
      // console.log(DailyDealOneIds);

      // 1. Create Price Dictionary
      for (var i = 0; i < arrayLength; i++) {
        DailyDealOnePrices[myArray[i].title] = myArray[i].price;
      }
      // console.log(DailyDealOnePrices);

      // 2. Create Variant ID Dictionary
      var myArray = data.products[1].variants;
      // console.log(myArray);
      var arrayLength = myArray.length;
      for (var i = 0; i < arrayLength; i++) {
        var variant_id = myArray[i].id;
        // console.log(id);
        DailyDealTwoIds[myArray[i].title] = variant_id;
      }  
      // console.log(DailyDealTwoIds);

      // 2. Create Price Dictionary
      for (var i = 0; i < arrayLength; i++) {
        DailyDealTwoPrices[myArray[i].title] = myArray[i].price;
      }
       //console.log(DailyDealTwoPrices);

      // 3. Create Variant ID Dictionary
      var myArray = data.products[2].variants;
      // console.log(myArray);
      var arrayLength = myArray.length;
      for (var i = 0; i < arrayLength; i++) {
        var variant_id = myArray[i].id;
        // console.log(id);
        DailyDealThreeIds[myArray[i].title] = variant_id;
      }  
      // console.log(DailyDealThreeIds);

      // 3. Create Price Dictionary
      for (var i = 0; i < arrayLength; i++) {
        DailyDealThreePrices[myArray[i].title] = myArray[i].price;
      }
      // console.log(DailyDealThreePrices);

      // 4. Create Variant ID Dictionary
      var myArray = data.products[3].variants;
      // console.log(myArray);
      var arrayLength = myArray.length;
      for (var i = 0; i < arrayLength; i++) {
        var variant_id = myArray[i].id;
        // console.log(id);
        DailyDealFourIds[myArray[i].title] = variant_id;
      }  
      // console.log(DailyDealFourIds);

      // 4. Create Price Dictionary
      for (var i = 0; i < arrayLength; i++) {
        DailyDealFourPrices[myArray[i].title] = myArray[i].price;
      }
       // console.log(DailyDealFourPrices);
	}
  
});

function setVariantandPrices(product_id,id_dict,price_dict){
  $('.single-option-selector-'+product_id).on('change', function() {
      /* Selected Variant */
      var value0 = $('#SingleOptionSelector-0-'+product_id).val();
      //console.log('type: '+value0);
      var value1 = $('#SingleOptionSelector-1-'+product_id).val();
      //console.log('size: '+value1);
      var value2 = $('#SingleOptionSelector-2-'+product_id).val();
      //console.log('color: '+value2);
      var variant = value0 + ' / ' + value1 + ' / ' + value2;
      // console.log('variant: '+ variant);

      /* Selected Variant ID */
      var selectedVariantId = id_dict[variant];
      // console.log('selected variant id: '+ selectedVariantId);

      /* When you jump to a Type with previously selected size not available, Update Selected Variant ID */
      if (selectedVariantId == undefined)
      {
          if (value0 == "T-Shirts, Youth")
          {
              value1 = "XS";
          } else if (value0 == "T-Shirts, Tall") {
              value1 = "Large";
          } else if (value0 == "Posters") {
            value1 = '4"x6"';
          } else {
              value1 = "Small";
          }
          variant = value0 + ' / ' + value1 + ' / ' + value2;
          selectedVariantId = id_dict[variant];
           // console.log('updated variant: '+ variant);
           // console.log('updated selected variant id: '+ selectedVariantId);
      }  	

      /* Selected Variant Price */
      var selectedVariantPrice = price_dict[variant];
      // console.log('selected variant price: '+ selectedVariantPrice)


      /* Set the correct Variant ID to pass to the Add to Cart button*/
      selectElement('ProductSelect-'+product_id, selectedVariantId);
      //console.log('variant is set');

      /* Set the correct Variant Price to display on the page*/
      $('.frontpage .product-card.pid-'+product_id+' span.price-item.price-item--regular').text('$'+selectedVariantPrice);
      //console.log('-- price is set --');
  });
}

$.getJSON('https://shirtpunch-store.myshopify.com/collections/frontpage/products.json', function(data) {
  
  if (data.products.length != 0){
  
    var product_1_id = data.products[0].id;
    var product_2_id = data.products[1].id;
    var product_3_id = data.products[2].id;
    var product_4_id = data.products[3].id;

    setVariantandPrices(product_1_id,DailyDealOneIds,DailyDealOnePrices);
    setVariantandPrices(product_2_id,DailyDealTwoIds,DailyDealTwoPrices);
    setVariantandPrices(product_3_id,DailyDealThreeIds,DailyDealThreePrices);
    setVariantandPrices(product_4_id,DailyDealFourIds,DailyDealFourPrices);
  }
  
});